import { Pipe, NgModule } from '@angular/core';
import Autolinker from 'autolinker';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LinkyPipe = /** @class */ (function () {
    function LinkyPipe() {
    }
    /**
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    LinkyPipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        return Autolinker.link(value, options);
    };
    LinkyPipe.decorators = [
        { type: Pipe, args: [{ name: 'linky' },] }
    ];
    return LinkyPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LinkyModule = /** @class */ (function () {
    function LinkyModule() {
    }
    LinkyModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [LinkyPipe],
                    exports: [LinkyPipe],
                },] }
    ];
    return LinkyModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { LinkyModule, LinkyPipe };
//# sourceMappingURL=ngx-linky.js.map
